// extracted by mini-css-extract-plugin
export default {"flex":"queries_flex__cA5Ht","header":"queries_header__9x6dT","search_wrapper":"queries_search_wrapper__PanYU"};